<template>
<div
v-observe-visibility="{
  callback: handleScroll,
  once: true
  }"
  :class="{fadeIn: isVisible}">
<slot v-show="visible"></slot>
</div>
</template>

<script>
export default {
  data(){
    return {
      isVisible: false
    }
  },
  methods: {
    handleScroll(isVisible, entry) {
      this.isVisible = isVisible;
      console.log(entry);
    }
  }
}
</script>

<style lang="scss" scoped>
.fadeIn {
  animation: fadeIn 1.3s ease;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}
</style>